import DesignSystem from '@wewiink/design-system'

export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.use(DesignSystem)
  }
})
